import React, { Component } from "react";
import { PiGauge, PiChartBar } from "react-icons/pi";
import "./evs-detail-tabs.css";

const TABS = [
	{ id: "score-analysis", label: "Score Analysis", icon: PiGauge },
	{ id: "campaigns", label: "Campaigns", icon: PiChartBar },
];

export default class EvsDetailTabs extends Component {
	render() {
		const { activeTab, onTabChange } = this.props;

		return (
			<div className="evs-detail-tabs">
				<div className="evs-detail-tabs__list">
					{TABS.map(({ id, label, icon: Icon }) => (
						<button
							key={id}
							type="button"
							className={`evs-detail-tabs__tab ${activeTab === id ? "evs-detail-tabs__tab--active" : ""}`}
							onClick={() => onTabChange && onTabChange(id)}
						>
							<Icon className="evs-detail-tabs__tab-icon" />
							<span>{label}</span>
						</button>
					))}
				</div>
			</div>
		);
	}
}
